import script from "./MoleculeModalGoal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeModalGoal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeModalGoal.vue?vue&type=style&index=0&id=6632a299&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6632a299"]])

export default __exports__